const tabItems = document.querySelectorAll('.delivery-zones__nav-item'),
      tabContents = document.querySelectorAll('.delivery-zones__content');

if(tabItems && tabContents) {
  tabItems[0]?.classList.add('active')
  tabContents[0]?.classList.add('active')
  tabItems?.forEach((item, i) => {
    item?.addEventListener('click', () => {
      if(item?.classList.contains('active')) return
  
      tabItems?.forEach(t => t.classList.remove('active'))
      tabContents?.forEach(t => t.classList.remove('active'))
  
      item?.classList.add('active')
      tabContents[i]?.classList.add('active')
    })
  })
}